const PhoneAbnormal = () =>
  import('@/views/main/helper/phoneAbnormal/PhoneAbnormal.vue')
export default {
  path: '/main/helper/phoneAbnormal',
  name: 'PhoneAbnormal',
  component: PhoneAbnormal
}
